"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExperimentWithVersion = void 0;
var ExperimentID_1 = require("./ExperimentID");
var ExperimentWithVersion = (function () {
    function ExperimentWithVersion(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new ExperimentID_1.ExperimentID(data.id);
        this.version = data.version;
    }
    ExperimentWithVersion.prototype.getPackageName = function () { return ExperimentWithVersion.PackageName; };
    ExperimentWithVersion.prototype.getClassName = function () { return ExperimentWithVersion.ClassName; };
    ExperimentWithVersion.prototype.getFullClassName = function () { return ExperimentWithVersion.FullClassName; };
    Object.defineProperty(ExperimentWithVersion.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ExperimentWithVersion.prototype, "version", {
        get: function () {
            return this._version;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field version is not optional');
            }
            if (typeof value !== 'number') {
                throw new Error('Field version expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field version is expected to be an integer, got ' + value);
            }
            if (value < 0) {
                throw new Error('Field version is expected to be not less than 0, got ' + value);
            }
            if (value > 4294967295) {
                throw new Error('Field version is expected to be not greater than 4294967295, got ' + value);
            }
            this._version = value;
        },
        enumerable: false,
        configurable: true
    });
    ExperimentWithVersion.prototype.serialize = function () {
        return {
            id: this.id.serialize(),
            version: this.version
        };
    };
    ExperimentWithVersion.PackageName = 'net.playq.octopus2.analytics';
    ExperimentWithVersion.ClassName = 'ExperimentWithVersion';
    ExperimentWithVersion.FullClassName = 'net.playq.octopus2.analytics.ExperimentWithVersion';
    return ExperimentWithVersion;
}());
exports.ExperimentWithVersion = ExperimentWithVersion;
var irt_1 = require("@playq/irt");
irt_1.Introspector.register(ExperimentWithVersion.FullClassName, {
    full: ExperimentWithVersion.FullClassName,
    short: ExperimentWithVersion.ClassName,
    package: ExperimentWithVersion.PackageName,
    type: irt_1.IntrospectorTypes.Data,
    ctor: function () { return new ExperimentWithVersion(); },
    fields: [
        {
            name: 'id',
            accessName: 'id',
            type: { intro: irt_1.IntrospectorTypes.Id, full: 'net.playq.octopus2.analytics.ExperimentID' }
        },
        {
            name: 'version',
            accessName: 'version',
            type: { intro: irt_1.IntrospectorTypes.U32 }
        }
    ]
});
//# sourceMappingURL=ExperimentWithVersion.js.map